import { ApiProperty } from '@nestjs/swagger'
import { IsNotEmpty, IsUUID, ArrayNotEmpty, IsArray } from 'class-validator'

export class ReorderActivitiesDto {
  @ApiProperty({
    description: "Liste ordonnée des IDs d'activités",
    type: [String],
    example: [
      '550e8400-e29b-41d4-a716-446655440000',
      '660e8400-e29b-41d4-a716-446655440001',
    ],
  })
  @IsArray()
  @ArrayNotEmpty()
  @IsUUID('4', { each: true })
  activityIds!: string[]
}
